import React from "react";
import ReactDOM from "react-dom/client";

import { store } from "./app/store";

import { Provider } from "react-redux";

import { Auth0Provider } from "@auth0/auth0-react";

import App from './App';
import AuthLoadingWrapper from '@/components/AuthLoadingWrapper';

import reportWebVitals from "./reportWebVitals";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { ConfigProvider, App as AntdApp } from "antd";

import "./index.scss";

import { buildAuth0AuthorizationParams } from '@/lib/auth0AuthorizationParams';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const primary = "#e21e26";
const auth0Domain = (
  process.env.REACT_APP_AUTH0_DOMAIN ||
  process.env.REACT_APP_AUTH0_ISSUER_BASE_URL ||
  ""
)
  .replace(/^https?:\/\//, "")
  .replace(/\/$/, "");
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Auth0Provider
      domain={auth0Domain}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ""}
      authorizationParams={buildAuth0AuthorizationParams({
        redirect_uri: window.location.origin,
      })}
      onRedirectCallback={(appState) => {
        const returnTo =
          typeof appState?.returnTo === 'string' && appState.returnTo.length > 0
            ? appState.returnTo
            : '/dashboard';
        window.location.replace(returnTo);
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <AuthLoadingWrapper>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: primary,
              colorError: primary,
              colorLink: primary,
            },

            components: {
              Button: {
                colorPrimary: primary,
                algorithm: true,
              },
              Slider: {
                controlSize: 6,
                dotSize: 0,
                handleActiveColor: primary,
                railBg: primary,
                railHoverBg: primary,
                railSize: 6,
                trackBg: primary,
                trackHoverBg: primary,
                handleColorDisabled: primary,
                dotBorderColor: primary,
                dotActiveBorderColor: primary,
              },
              Switch: {
                handleShadow: primary,
                colorPrimary: primary,
              },
            },
          }}
        >
          <AntdApp>
            <App />
          </AntdApp>
        </ConfigProvider>
      </AuthLoadingWrapper>
    </Auth0Provider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
